import { action, makeAutoObservable } from "mobx";
import * as _ from "lodash";
import axios, { AxiosInstance } from "axios";

import env from "../../../config/env";
import http from "../../../services/http";
import {
  MessageResultState,
  ServiceResult,
} from "../../../types/general-types";
import IPagedResult from "../../../models/dto/fetch/IPagedResult";
import { ClientDto } from "./types";

const { API_BASE_URL } = env;
let reportPeriod: string = "";

class Store {
  static readonly id: string = "ClientManagementStore";

  get api(): AxiosInstance {
    http.defaults.baseURL = API_BASE_URL;
    return http;
  }

  constructor() {
    makeAutoObservable(this);
  }

  @action.bound async getAll() {
    let response: ServiceResult<ClientDto[]> = await (
      await this.api.get(`/client/get-all`)
    ).data;
    return response;
  }

  @action.bound async getUserClients() {
    let response: ServiceResult<ClientDto[]> = await (
      await this.api.get(`/client/get-user-clients`)
    ).data;
    return response;
  }

  @action.bound async getById(id: string) {
    let response: ServiceResult<ClientDto> = await (
      await this.api.get(`/client/get-by-id/` + id)
    ).data;
    return response;
  }

  @action.bound async create(dto: ClientDto) {
    let response: ServiceResult<ClientDto> = await (
      await this.api.post(`/client/create`, dto)
    ).data;
    return response;
  }

  @action.bound async update(dto: ClientDto) {
    let response: ServiceResult<ClientDto> = await (
      await this.api.post(`/client/update`, dto)
    ).data;
    return response;
  }

  @action.bound async delete(id: string) {
    let response: ServiceResult<ClientDto> = await (
      await this.api.delete(`/client/delete/` + id)
    ).data;
    return response;
  }

  @action.bound async Translation(text: string) {
    let response: ServiceResult<string> = await (
      await this.api.post(`/openai-integration/translation`, { text: text })
    ).data;
    return response;
  }
}

export default Store;
